"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CosmosAccount = exports.AccountWithCosmos = void 0;
const base_1 = require("./base");
const common_1 = require("@keplr-wallet/common");
const unit_1 = require("@keplr-wallet/unit");
const cosmos_1 = require("@keplr-wallet/cosmos");
const types_1 = require("../query/cosmos/staking/types");
const long_1 = __importDefault(require("long"));
class AccountWithCosmos extends base_1.AccountSetBase {
    constructor(eventListener, chainGetter, chainId, queriesStore, opts) {
        super(eventListener, chainGetter, chainId, queriesStore, opts);
        this.eventListener = eventListener;
        this.chainGetter = chainGetter;
        this.chainId = chainId;
        this.queriesStore = queriesStore;
        this.opts = opts;
        this.cosmos = new CosmosAccount(this, chainGetter, chainId, queriesStore);
    }
}
exports.AccountWithCosmos = AccountWithCosmos;
AccountWithCosmos.defaultMsgOpts = {
    send: {
        native: {
            type: "cosmos-sdk/MsgSend",
            gas: 80000,
        },
    },
    ibcTransfer: {
        type: "cosmos-sdk/MsgTransfer",
        gas: 450000,
    },
    delegate: {
        type: "cosmos-sdk/MsgDelegate",
        gas: 250000,
    },
    undelegate: {
        type: "cosmos-sdk/MsgUndelegate",
        gas: 250000,
    },
    redelegate: {
        type: "cosmos-sdk/MsgBeginRedelegate",
        gas: 250000,
    },
    // The gas multiplication per rewards.
    withdrawRewards: {
        type: "cosmos-sdk/MsgWithdrawDelegationReward",
        gas: 140000,
    },
    govVote: {
        type: "cosmos-sdk/MsgVote",
        gas: 250000,
    },
};
class CosmosAccount {
    constructor(base, chainGetter, chainId, queriesStore) {
        this.base = base;
        this.chainGetter = chainGetter;
        this.chainId = chainId;
        this.queriesStore = queriesStore;
        this.base.registerSendTokenFn(this.processSendToken.bind(this));
    }
    processSendToken(amount, currency, recipient, memo, stdFee, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const denomHelper = new common_1.DenomHelper(currency.coinMinimalDenom);
            switch (denomHelper.type) {
                case "native":
                    const actualAmount = (() => {
                        let dec = new unit_1.Dec(amount);
                        dec = dec.mul(unit_1.DecUtils.getPrecisionDec(currency.coinDecimals));
                        return dec.truncate().toString();
                    })();
                    const msg = {
                        type: this.base.msgOpts.send.native.type,
                        value: {
                            from_address: this.base.bech32Address,
                            to_address: recipient,
                            amount: [
                                {
                                    denom: currency.coinMinimalDenom,
                                    amount: actualAmount,
                                },
                            ],
                        },
                    };
                    yield this.base.sendMsgs("send", {
                        aminoMsgs: [msg],
                        protoMsgs: this.hasNoLegacyStdFeature()
                            ? [
                                {
                                    type_url: "/cosmos.bank.v1beta1.MsgSend",
                                    value: cosmos_1.cosmos.bank.v1beta1.MsgSend.encode({
                                        fromAddress: msg.value.from_address,
                                        toAddress: msg.value.to_address,
                                        amount: msg.value.amount,
                                    }).finish(),
                                },
                            ]
                            : undefined,
                    }, memo, {
                        amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                        gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.send.native.gas.toString(),
                    }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                        if (tx.code == null || tx.code === 0) {
                            // After succeeding to send token, refresh the balance.
                            const queryBalance = this.queries.queryBalances
                                .getQueryBech32Address(this.base.bech32Address)
                                .balances.find((bal) => {
                                return (bal.currency.coinMinimalDenom === currency.coinMinimalDenom);
                            });
                            if (queryBalance) {
                                queryBalance.fetch();
                            }
                        }
                    }));
                    return true;
            }
            return false;
        });
    }
    sendIBCTransferMsg(channel, amount, currency, recipient, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (new common_1.DenomHelper(currency.coinMinimalDenom).type !== "native") {
                throw new Error("Only native token can be sent via IBC");
            }
            const actualAmount = (() => {
                let dec = new unit_1.Dec(amount);
                dec = dec.mul(unit_1.DecUtils.getPrecisionDec(currency.coinDecimals));
                return dec.truncate().toString();
            })();
            const destinationBlockHeight = this.queriesStore
                .get(channel.counterpartyChainId)
                .cosmos.queryBlock.getBlock("latest");
            yield this.base.sendMsgs("ibcTransfer", () => __awaiter(this, void 0, void 0, function* () {
                // Wait until fetching complete.
                yield destinationBlockHeight.waitFreshResponse();
                if (destinationBlockHeight.height.equals(new unit_1.Int("0"))) {
                    throw new Error(`Failed to fetch the latest block of ${channel.counterpartyChainId}`);
                }
                const msg = {
                    type: this.base.msgOpts.ibcTransfer.type,
                    value: {
                        source_port: channel.portId,
                        source_channel: channel.channelId,
                        token: {
                            denom: currency.coinMinimalDenom,
                            amount: actualAmount,
                        },
                        sender: this.base.bech32Address,
                        receiver: recipient,
                        timeout_height: {
                            revision_number: cosmos_1.ChainIdHelper.parse(channel.counterpartyChainId).version.toString(),
                            // Set the timeout height as the current height + 150.
                            revision_height: destinationBlockHeight.height
                                .add(new unit_1.Int("150"))
                                .toString(),
                        },
                    },
                };
                if (msg.value.timeout_height.revision_number === "0") {
                    delete msg.value.timeout_height.revision_number;
                }
                return {
                    aminoMsgs: [msg],
                    protoMsgs: [
                        {
                            type_url: "/ibc.applications.transfer.v1.MsgTransfer",
                            value: cosmos_1.ibc.applications.transfer.v1.MsgTransfer.encode({
                                sourcePort: msg.value.source_port,
                                sourceChannel: msg.value.source_channel,
                                token: msg.value.token,
                                sender: msg.value.sender,
                                receiver: msg.value.receiver,
                                timeoutHeight: {
                                    revisionNumber: msg.value.timeout_height.revision_number
                                        ? long_1.default.fromString(msg.value.timeout_height.revision_number)
                                        : null,
                                    revisionHeight: long_1.default.fromString(msg.value.timeout_height.revision_height),
                                },
                            }).finish(),
                        },
                    ],
                };
            }), memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.ibcTransfer.gas.toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to send token, refresh the balance.
                    const queryBalance = this.queries.queryBalances
                        .getQueryBech32Address(this.base.bech32Address)
                        .balances.find((bal) => {
                        return (bal.currency.coinMinimalDenom === currency.coinMinimalDenom);
                    });
                    if (queryBalance) {
                        queryBalance.fetch();
                    }
                }
            }));
        });
    }
    /**
     * Send `MsgDelegate` msg to the chain.
     * @param amount Decimal number used by humans.
     *               If amount is 0.1 and the stake currenct is uatom, actual amount will be changed to the 100000uatom.
     * @param validatorAddress
     * @param memo
     * @param onFulfill
     */
    sendDelegateMsg(amount, validatorAddress, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const currency = this.chainGetter.getChain(this.chainId).stakeCurrency;
            let dec = new unit_1.Dec(amount);
            dec = dec.mulTruncate(unit_1.DecUtils.getPrecisionDec(currency.coinDecimals));
            const msg = {
                type: this.base.msgOpts.delegate.type,
                value: {
                    delegator_address: this.base.bech32Address,
                    validator_address: validatorAddress,
                    amount: {
                        denom: currency.coinMinimalDenom,
                        amount: dec.truncate().toString(),
                    },
                },
            };
            yield this.base.sendMsgs("delegate", {
                aminoMsgs: [msg],
                protoMsgs: this.hasNoLegacyStdFeature()
                    ? [
                        {
                            type_url: "/cosmos.staking.v1beta1.MsgDelegate",
                            value: cosmos_1.cosmos.staking.v1beta1.MsgDelegate.encode({
                                delegatorAddress: msg.value.delegator_address,
                                validatorAddress: msg.value.validator_address,
                                amount: msg.value.amount,
                            }).finish(),
                        },
                    ]
                    : undefined,
            }, memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.delegate.gas.toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to delegate, refresh the validators and delegations, rewards.
                    this.queries.cosmos.queryValidators
                        .getQueryStatus(types_1.BondStatus.Bonded)
                        .fetch();
                    this.queries.cosmos.queryDelegations
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                    this.queries.cosmos.queryRewards
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                }
            }));
        });
    }
    /**
     * Send `MsgUndelegate` msg to the chain.
     * @param amount Decimal number used by humans.
     *               If amount is 0.1 and the stake currenct is uatom, actual amount will be changed to the 100000uatom.
     * @param validatorAddress
     * @param memo
     * @param onFulfill
     */
    sendUndelegateMsg(amount, validatorAddress, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const currency = this.chainGetter.getChain(this.chainId).stakeCurrency;
            let dec = new unit_1.Dec(amount);
            dec = dec.mulTruncate(unit_1.DecUtils.getPrecisionDec(currency.coinDecimals));
            const msg = {
                type: this.base.msgOpts.undelegate.type,
                value: {
                    delegator_address: this.base.bech32Address,
                    validator_address: validatorAddress,
                    amount: {
                        denom: currency.coinMinimalDenom,
                        amount: dec.truncate().toString(),
                    },
                },
            };
            yield this.base.sendMsgs("undelegate", {
                aminoMsgs: [msg],
                protoMsgs: [
                    {
                        type_url: "/cosmos.staking.v1beta1.MsgUndelegate",
                        value: cosmos_1.cosmos.staking.v1beta1.MsgUndelegate.encode({
                            delegatorAddress: msg.value.delegator_address,
                            validatorAddress: msg.value.validator_address,
                            amount: msg.value.amount,
                        }).finish(),
                    },
                ],
            }, memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.undelegate.gas.toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to unbond, refresh the validators and delegations, unbonding delegations, rewards.
                    this.queries.cosmos.queryValidators
                        .getQueryStatus(types_1.BondStatus.Bonded)
                        .fetch();
                    this.queries.cosmos.queryDelegations
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                    this.queries.cosmos.queryUnbondingDelegations
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                    this.queries.cosmos.queryRewards
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                }
            }));
        });
    }
    /**
     * Send `MsgBeginRedelegate` msg to the chain.
     * @param amount Decimal number used by humans.
     *               If amount is 0.1 and the stake currenct is uatom, actual amount will be changed to the 100000uatom.
     * @param srcValidatorAddress
     * @param dstValidatorAddress
     * @param memo
     * @param onFulfill
     */
    sendBeginRedelegateMsg(amount, srcValidatorAddress, dstValidatorAddress, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const currency = this.chainGetter.getChain(this.chainId).stakeCurrency;
            let dec = new unit_1.Dec(amount);
            dec = dec.mulTruncate(unit_1.DecUtils.getPrecisionDec(currency.coinDecimals));
            const msg = {
                type: this.base.msgOpts.redelegate.type,
                value: {
                    delegator_address: this.base.bech32Address,
                    validator_src_address: srcValidatorAddress,
                    validator_dst_address: dstValidatorAddress,
                    amount: {
                        denom: currency.coinMinimalDenom,
                        amount: dec.truncate().toString(),
                    },
                },
            };
            yield this.base.sendMsgs("redelegate", {
                aminoMsgs: [msg],
                protoMsgs: this.hasNoLegacyStdFeature()
                    ? [
                        {
                            type_url: "/cosmos.staking.v1beta1.MsgBeginRedelegate",
                            value: cosmos_1.cosmos.staking.v1beta1.MsgBeginRedelegate.encode({
                                delegatorAddress: msg.value.delegator_address,
                                validatorSrcAddress: msg.value.validator_src_address,
                                validatorDstAddress: msg.value.validator_dst_address,
                                amount: msg.value.amount,
                            }).finish(),
                        },
                    ]
                    : undefined,
            }, memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.redelegate.gas.toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to redelegate, refresh the validators and delegations, rewards.
                    this.queries.cosmos.queryValidators
                        .getQueryStatus(types_1.BondStatus.Bonded)
                        .fetch();
                    this.queries.cosmos.queryDelegations
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                    this.queries.cosmos.queryRewards
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                }
            }));
        });
    }
    sendWithdrawDelegationRewardMsgs(validatorAddresses, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const msgs = validatorAddresses.map((validatorAddress) => {
                return {
                    type: this.base.msgOpts.withdrawRewards.type,
                    value: {
                        delegator_address: this.base.bech32Address,
                        validator_address: validatorAddress,
                    },
                };
            });
            yield this.base.sendMsgs("withdrawRewards", {
                aminoMsgs: msgs,
                protoMsgs: this.hasNoLegacyStdFeature()
                    ? msgs.map((msg) => {
                        return {
                            type_url: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
                            value: cosmos_1.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward.encode({
                                delegatorAddress: msg.value.delegator_address,
                                validatorAddress: msg.value.validator_address,
                            }).finish(),
                        };
                    })
                    : undefined,
            }, memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : (this.base.msgOpts.withdrawRewards.gas * validatorAddresses.length).toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to withdraw rewards, refresh rewards.
                    this.queries.cosmos.queryRewards
                        .getQueryBech32Address(this.base.bech32Address)
                        .fetch();
                }
            }));
        });
    }
    sendGovVoteMsg(proposalId, option, memo = "", stdFee = {}, signOptions, onTxEvents) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const voteOption = (() => {
                var _a;
                if ((_a = this.chainGetter.getChain(this.chainId).features) === null || _a === void 0 ? void 0 : _a.includes("stargate")) {
                    switch (option) {
                        case "Yes":
                            return 1;
                        case "Abstain":
                            return 2;
                        case "No":
                            return 3;
                        case "NoWithVeto":
                            return 4;
                    }
                }
                else {
                    return option;
                }
            })();
            const msg = {
                type: this.base.msgOpts.govVote.type,
                value: {
                    option: voteOption,
                    proposal_id: proposalId,
                    voter: this.base.bech32Address,
                },
            };
            yield this.base.sendMsgs("govVote", {
                aminoMsgs: [msg],
                protoMsgs: this.hasNoLegacyStdFeature()
                    ? [
                        {
                            type_url: "/cosmos.gov.v1beta1.MsgVote",
                            value: cosmos_1.cosmos.gov.v1beta1.MsgVote.encode({
                                proposalId: long_1.default.fromString(msg.value.proposal_id),
                                voter: msg.value.voter,
                                option: (() => {
                                    switch (msg.value.option) {
                                        case "Yes":
                                        case 1:
                                            return cosmos_1.cosmos.gov.v1beta1.VoteOption.VOTE_OPTION_YES;
                                        case "Abstain":
                                        case 2:
                                            return cosmos_1.cosmos.gov.v1beta1.VoteOption
                                                .VOTE_OPTION_ABSTAIN;
                                        case "No":
                                        case 3:
                                            return cosmos_1.cosmos.gov.v1beta1.VoteOption.VOTE_OPTION_NO;
                                        case "NoWithVeto":
                                        case 4:
                                            return cosmos_1.cosmos.gov.v1beta1.VoteOption
                                                .VOTE_OPTION_NO_WITH_VETO;
                                        default:
                                            return cosmos_1.cosmos.gov.v1beta1.VoteOption
                                                .VOTE_OPTION_UNSPECIFIED;
                                    }
                                })(),
                            }).finish(),
                        },
                    ]
                    : undefined,
            }, memo, {
                amount: (_a = stdFee.amount) !== null && _a !== void 0 ? _a : [],
                gas: (_b = stdFee.gas) !== null && _b !== void 0 ? _b : this.base.msgOpts.govVote.gas.toString(),
            }, signOptions, this.txEventsWithPreOnFulfill(onTxEvents, (tx) => {
                if (tx.code == null || tx.code === 0) {
                    // After succeeding to vote, refresh the proposal.
                    const proposal = this.queries.cosmos.queryGovernance.proposals.find((proposal) => proposal.id === proposalId);
                    if (proposal) {
                        proposal.fetch();
                    }
                    const vote = this.queries.cosmos.queryProposalVote.getVote(proposalId, this.base.bech32Address);
                    vote.fetch();
                }
            }));
        });
    }
    txEventsWithPreOnFulfill(onTxEvents, preOnFulfill) {
        if (!onTxEvents) {
            return;
        }
        const onBroadcasted = typeof onTxEvents === "function" ? undefined : onTxEvents.onBroadcasted;
        const onFulfill = typeof onTxEvents === "function" ? onTxEvents : onTxEvents.onFulfill;
        return {
            onBroadcasted,
            onFulfill: onFulfill || preOnFulfill
                ? (tx) => {
                    if (preOnFulfill) {
                        preOnFulfill(tx);
                    }
                    if (onFulfill) {
                        onFulfill(tx);
                    }
                }
                : undefined,
        };
    }
    get queries() {
        return this.queriesStore.get(this.chainId);
    }
    hasNoLegacyStdFeature() {
        const chainInfo = this.chainGetter.getChain(this.chainId);
        return (chainInfo.features != null &&
            chainInfo.features.includes("no-legacy-stdTx"));
    }
}
exports.CosmosAccount = CosmosAccount;
//# sourceMappingURL=cosmos.js.map